import firebase from '@/firebase'
import router from '@/router'
const state = {
    user: null,
}
const actions = {
    async login({commit},credentials){
        try{
            const res =  await  firebase.auth().signInWithEmailAndPassword(credentials.email, credentials.password)
            const user = {
                email: res.user.email,
                uid: res.user.uid
            }
            localStorage.setItem('user', JSON.stringify(user))
            commit('SET_USER', user)
            await router.push('/admin-cms')
        }catch (e){
           console.log(e)
            return(e)
        }
    },
    // async register({commit},credentials){
    //     // return console.log('vuex', credentials)
    //     try{
    //         const res =  await  firebase.auth().createUserWithEmailAndPassword(credentials.email, credentials.password)
    //         commit('SET_USER', res)
    //     }catch (e){
    //         console.log(e)
    //     }
    // },
    validateSession({ commit }) {
        if (localStorage.getItem("user")) {
            console.log('validated')
          commit("SET_USER", JSON.parse(localStorage.getItem("user")));
          router.push("/admin-cms");
        } else {
          commit("SET_USER", null);
          router.push("/admin-login");
        }
      },
    async logout({commit}){
        localStorage.removeItem("user");
        commit("SET_USER", null);
        router.push("/admin-login");
    }
}
const mutations = {
    SET_USER(state, credentials){
        state.user = credentials
    }
}
const getters = {
    userIsAuthenticated(state) {
        return !!state.user;
      },
}

export default {
    namespaced: true,
    state, actions, mutations, getters
}